import PowerIcon from '@mui/icons-material/Power';
import BatteryChargingIcon from '@mui/icons-material/BatteryCharging60';
import PowerOffIcon from '@mui/icons-material/PowerOff';
import type { ChargePoint } from '@shared/types/data.types.ts';
import { ChargePointStatus } from '@services/swagger-client/data-contracts.ts';
import type { JSX } from 'react';

export const getChargePointStatusIcon = (status: ChargePoint['status']): JSX.Element => {
  switch (status) {
    case ChargePointStatus.Charging: {
      return <BatteryChargingIcon color='success' />;
    }
    case ChargePointStatus.Available: {
      return <PowerIcon color='success' />;
    }
    case ChargePointStatus.Preparing:
    case ChargePointStatus.Reserved:
    case ChargePointStatus.Finishing:
    case ChargePointStatus.SuspendedEV:
    case ChargePointStatus.SuspendedEVSE: {
      return <PowerIcon color='warning' />;
    }
    case ChargePointStatus.Faulted:
    case ChargePointStatus.Unavailable: {
      return <PowerOffIcon color='error' />;
    }
  }
};
